
import { useState } from 'react';

export default function Gallery() {
  const [activeSlider, setActiveSlider] = useState<number | null>(null);

  const projects = [
    {
      name: 'Luxury Penthouse',
      category: 'Residential',
      before:
        'https://public.readdy.ai/ai/img_res/effb1cc776b570500d5f06901f3379c2.jpg',
      after:
        'https://readdy.ai/api/search-image?query=stunning%20luxury%20penthouse%20interior%20after%20renovation%20marble%20surfaces%20gold%20fixtures%20contemporary%20furniture%20sophisticated%20lighting%20floor%20to%20ceiling%20windows%20premium%20finishes%20elegant%20design%20high%20end%20residential%20transformation%20beautiful%20modern%20aesthetic&width=800&height=600&seq=after-penthouse-001&orientation=landscape',
    },
    {
      name: 'Corporate Office',
      category: 'Commercial',
      before:
        'https://readdy.ai/api/search-image?query=old%20traditional%20office%20space%20before%20renovation%20outdated%20cubicles%20fluorescent%20lighting%20beige%20walls%20worn%20carpet%20basic%20furniture%20uninspiring%20workspace%20needs%20modernization%20dull%20corporate%20environment%20lacking%20style&width=800&height=600&seq=before-office-001&orientation=landscape',
      after:
        'https://readdy.ai/api/search-image?query=modern%20luxury%20corporate%20office%20after%20renovation%20open%20plan%20workspace%20contemporary%20design%20marble%20reception%20desk%20gold%20accents%20sophisticated%20lighting%20premium%20finishes%20elegant%20professional%20environment%20high%20end%20commercial%20transformation&width=800&height=600&seq=after-office-001&orientation=landscape',
    },
    {
      name: 'Heritage Home',
      category: 'Residential',
      before:
        'https://readdy.ai/api/search-image?query=old%20heritage%20home%20interior%20before%20renovation%20dated%20features%20worn%20surfaces%20outdated%20kitchen%20basic%20bathroom%20needs%20restoration%20tired%20appearance%20lacking%20modern%20amenities%20traditional%20layout%20requiring%20update&width=800&height=600&seq=before-heritage-001&orientation=landscape',
      after:
        'https://readdy.ai/api/search-image?query=beautifully%20renovated%20heritage%20home%20interior%20blending%20classic%20architecture%20with%20modern%20luxury%20marble%20countertops%20gold%20fixtures%20contemporary%20appliances%20sophisticated%20lighting%20premium%20finishes%20elegant%20restoration%20high%20end%20residential%20transformation&width=800&height=600&seq=after-heritage-001&orientation=landscape',
    },
    {
      name: 'Boutique Retail',
      category: 'Commercial',
      before:
        'https://readdy.ai/api/search-image?query=basic%20retail%20store%20interior%20before%20renovation%20plain%20walls%20standard%20flooring%20simple%20lighting%20basic%20fixtures%20uninspiring%20layout%20needs%20upgrade%20lacking%20character%20ordinary%20commercial%20space%20requiring%20transformation&width=800&height=600&seq=before-retail-001&orientation=landscape',
      after:
        'https://readdy.ai/api/search-image?query=luxury%20boutique%20retail%20store%20after%20renovation%20marble%20flooring%20gold%20display%20fixtures%20sophisticated%20lighting%20contemporary%20design%20premium%20finishes%20elegant%20shopping%20environment%20high%20end%20commercial%20transformation%20beautiful%20modern%20aesthetic&width=800&height=600&seq=after-retail-001&orientation=landscape',
    },
    {
      name: 'Modern Villa Exterior',
      category: 'Residential',
      before:
        'https://readdy.ai/api/search-image?query=old%20dated%20luxury%20home%20exterior%20before%20renovation%20cracked%20driveway%20faded%20paint%20overgrown%20garden%20worn%20roof%20tiles%20outdated%20facade%20peeling%20walls%20neglected%20landscaping%20tired%20curb%20appeal%20suburban%20house%20needing%20complete%20exterior%20makeover%20clear%20sky%20background&width=800&height=600&seq=before-villa-ext-001&orientation=landscape',
      after:
        'https://readdy.ai/api/search-image?query=stunning%20modern%20luxury%20villa%20exterior%20after%20renovation%20sleek%20white%20rendered%20walls%20large%20glass%20windows%20manicured%20garden%20contemporary%20landscaping%20ambient%20outdoor%20lighting%20stone%20cladding%20accents%20premium%20driveway%20elegant%20entrance%20portico%20high%20end%20residential%20exterior%20transformation%20beautiful%20curb%20appeal&width=800&height=600&seq=after-villa-ext-001&orientation=landscape',
    },
    {
      name: 'Estate Facade Upgrade',
      category: 'Residential',
      before:
        'https://readdy.ai/api/search-image?query=rundown%20large%20estate%20home%20exterior%20before%20renovation%20faded%20brick%20walls%20old%20wooden%20windows%20cracked%20pathway%20overgrown%20yard%20dated%20roof%20missing%20gutters%20weathered%20front%20door%20neglected%20luxury%20property%20needing%20full%20exterior%20restoration%20daytime%20photo&width=800&height=600&seq=before-estate-ext-002&orientation=landscape',
      after:
        'https://readdy.ai/api/search-image?query=magnificent%20renovated%20luxury%20estate%20home%20exterior%20contemporary%20facade%20charcoal%20and%20cream%20render%20large%20aluminium%20framed%20windows%20designer%20front%20door%20landscaped%20garden%20with%20stone%20pathway%20outdoor%20wall%20sconces%20premium%20roof%20tiles%20elegant%20columns%20grand%20entrance%20high%20end%20residential%20exterior%20makeover&width=800&height=600&seq=after-estate-ext-002&orientation=landscape',
    },
    {
      name: 'Contemporary Home Exterior',
      category: 'Residential',
      before:
        'https://readdy.ai/api/search-image?query=plain%20suburban%20house%20exterior%20before%20renovation%20basic%20brickwork%20small%20windows%20old%20garage%20door%20simple%20concrete%20driveway%20no%20landscaping%20faded%20paint%20standard%20roof%20uninspiring%20curb%20appeal%20needs%20complete%20exterior%20transformation%20daytime%20clear%20sky&width=800&height=600&seq=before-contemp-ext-003&orientation=landscape',
      after:
        'https://readdy.ai/api/search-image?query=breathtaking%20contemporary%20luxury%20home%20exterior%20after%20renovation%20flat%20roof%20design%20floor%20to%20ceiling%20glass%20walls%20wooden%20cladding%20accents%20infinity%20pool%20visible%20designer%20outdoor%20furniture%20lush%20tropical%20landscaping%20warm%20ambient%20lighting%20premium%20stone%20paving%20stunning%20architectural%20transformation%20evening%20golden%20hour&width=800&height=600&seq=after-contemp-ext-003&orientation=landscape',
    },
    {
      name: 'Classic Mansion Revival',
      category: 'Residential',
      before:
        'https://readdy.ai/api/search-image?query=neglected%20old%20mansion%20exterior%20before%20renovation%20peeling%20stucco%20walls%20broken%20balustrades%20overgrown%20ivy%20cracked%20steps%20rusty%20gate%20faded%20shutters%20damaged%20roof%20ornate%20but%20deteriorating%20architecture%20grand%20property%20in%20disrepair%20needing%20luxury%20restoration%20daytime%20photo&width=800&height=600&seq=before-mansion-ext-004&orientation=landscape',
      after:
        'https://readdy.ai/api/search-image?query=gloriously%20restored%20luxury%20mansion%20exterior%20pristine%20white%20facade%20with%20gold%20trim%20ornate%20balustrades%20perfectly%20maintained%20restored%20columns%20grand%20entrance%20with%20double%20doors%20manicured%20formal%20garden%20fountain%20in%20courtyard%20premium%20slate%20roof%20elegant%20wrought%20iron%20gate%20high%20end%20heritage%20restoration%20evening%20lighting&width=800&height=600&seq=after-mansion-ext-004&orientation=landscape',
    },
  ];

  return (
    <section id="gallery" className="py-16 md:py-24 lg:py-32 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#2A2A2A] mb-6">
            Transformations
          </h2>
          <div className="flex items-center justify-center gap-2">
            <div className="w-8 h-0.5 bg-[#D4AF37]"></div>
            <div className="w-2 h-2 border-2 border-[#D4AF37] rotate-45"></div>
            <div className="w-8 h-0.5 bg-[#D4AF37]"></div>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-12">
          {projects.map((project, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl md:rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500"
            >
              {/* Before/After Comparison */}
              <div className="relative aspect-[4/3] overflow-hidden">
                {/* Before Image */}
                <img
                  src={project.before}
                  alt={`${project.name} Before`}
                  className="w-full h-full object-cover object-top"
                  style={{ filter: 'saturate(0.7)' }}
                />

                {/* After Image with Clip */}
                <div
                  className="absolute inset-0 transition-all duration-300"
                  style={{ clipPath: 'inset(0 0 0 50%)' }}
                >
                  <img
                    src={project.after}
                    alt={`${project.name} After`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                {/* Divider Line */}
                <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-[#D4AF37] -translate-x-1/2"></div>

                {/* Slider Handle */}
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 bg-[#D4AF37] rounded-full shadow-lg flex items-center justify-center cursor-pointer hover:scale-110 transition-transform">
                  <i className="ri-arrow-left-right-line text-white text-lg md:text-xl"></i>
                </div>

                {/* Before/After Labels */}
                <div className="absolute top-3 left-3 sm:top-6 sm:left-6 bg-white/90 backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-full">
                  <span className="text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wide">
                    Before
                  </span>
                </div>
                <div className="absolute top-3 right-3 sm:top-6 sm:right-6 bg-white/90 backdrop-blur-sm px-3 py-1.5 sm:px-4 sm:py-2 rounded-full">
                  <span className="text-[10px] sm:text-xs font-semibold text-gray-700 uppercase tracking-wide">
                    After
                  </span>
                </div>

                {/* Project Name Tag */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 -mt-12 sm:-mt-16 bg-white px-4 py-1.5 sm:px-6 sm:py-2 rounded-full shadow-md">
                  <span className="text-xs sm:text-sm font-semibold text-[#2A2A2A] uppercase tracking-wide whitespace-nowrap">
                    {project.name}
                  </span>
                </div>
              </div>

              {/* Info Bar */}
              <div className="p-4 md:p-6">
                <span className="text-xs font-semibold text-[#D4AF37] uppercase tracking-widest">
                  {project.category}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        <div className="text-center">
          <a
            href="#contact"
            className="inline-block px-8 md:px-12 py-3.5 md:py-4 border-2 border-[#D4AF37] text-[#D4AF37] text-sm md:text-base font-semibold rounded-full hover:bg-[#D4AF37] hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            View All Projects
          </a>
        </div>
      </div>
    </section>
  );
}
